<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <!-- <ngx-guided-tour skipText="Saltar" nextText="Proximo" doneText="Hecho" backText="Atras" ></ngx-guided-tour> -->

  <ion-router-outlet id="main"></ion-router-outlet>
  <ion-tabs #tabs (ionTabsDidChange)="setCurrentTab()">
    <ion-tab-bar *ngIf="!onPdf" slot="bottom">
      <ion-tab-button class="tab-publications" tab="publications">
        <ion-img class="on-icon" *ngIf="selectedTab == 'publications'" src="assets/icons/icono-publicaciones-on.png">
        </ion-img>
        <ion-img class="off-icon" *ngIf="selectedTab != 'publications'" src="assets/icons/icono-publicaciones-off.png">
        </ion-img>
      </ion-tab-button>

      <ion-tab-button class="tab-practice" tab="practice">
        <ion-img class="on-icon" *ngIf="selectedTab == 'practice'" src="assets/icons/icono-pratica_diaria-on.png">
        </ion-img>
        <ion-img class="off-icon" *ngIf="selectedTab != 'practice'" src="assets/icons/icono-pratica_diaria-off.png">
        </ion-img>
      </ion-tab-button>

      <ion-tab-button class="tab-old" tab="old-publications">
        <ion-img class="on-icon" *ngIf="selectedTab == 'old-publications'" src="assets/icons/icono-biblioteca-on.png">
        </ion-img>
        <ion-img class="off-icon" *ngIf="selectedTab != 'old-publications'" src="assets/icons/icono-biblioteca-off.png">
        </ion-img>
      </ion-tab-button>

      <ion-tab-button class="tab-series" tab="series">
        <ion-img class="on-icon" *ngIf="selectedTab == 'series'" src="assets/icons/icono-series-on.png"></ion-img>
        <ion-img class="off-icon" *ngIf="selectedTab != 'series'" src="assets/icons/icono-series-off.png"></ion-img>
      </ion-tab-button>
      <ion-tab-button class="tab-media" tab="media">
        <ion-img class="on-icon" *ngIf="selectedTab == 'media'" src="assets/icons/icono-media-on.png"></ion-img>
        <ion-img class="off-icon" *ngIf="selectedTab != 'media'" src="assets/icons/icono-media-off.png"></ion-img>
      </ion-tab-button>

    </ion-tab-bar>
  </ion-tabs>
</ion-app>